import React from 'react';
import { string } from 'prop-types';

const ShopperApprovedBlock = ({ sealId, reviewsUrl }) => {
    const handleContextMenu = (e) => {
        e.preventDefault();
        // eslint-disable-next-line no-undef
        var d = new Date(); alert('Copying Prohibited by Law - This image and all included logos are copyrighted by Shopper Approved (c) '+d.getFullYear()+'.');
        return false;
    };
    if (!sealId || !reviewsUrl) 
        return null;
    return (<div
        className={'mb-3'}>
        <a
            href={reviewsUrl}
            className={'shopperlink new-sa-seals placement-default'}>
            <img
                src={`//www.shopperapproved.com/seal/${sealId}/default-sa-seal.gif`}
                style={{ borderRadius: '4px' }}
                alt={'Customer Reviews'}
                onContextMenu={handleContextMenu} />
        </a>
    </div>);
};

ShopperApprovedBlock.propTypes = {
    sealId: string,
    reviewsUrl: string,
};

export default ShopperApprovedBlock;